export type DAFState = {
    /** Invariant key for this entry. Must be unique, must not change. If not set, timestamp will be used as the key */
    key: string | undefined;
    timestamp: string;  // ISO 8601 format 
    inletPH: SignalData;
    outletPH: SignalData;
    inletTSS: SignalData;
    outletTSS: SignalData;
    flowrate: SignalData;
}

export type SignalData = {
    value: number;
    alarm: boolean;
    alarmMessage: string | null;
    max: number | null;
    label: string | null;
    unit: number | null;
}

export const UnitLabels: Record<number, string> = {
    1: 'mg/L',
    2: 'NTU',
    3: 'L/hr',
    4: 'kL/hr',
};

export enum SensorType {
    InletPH = 1,
    OutletPH = 2,
    InletTSS = 3,
    OutletTSS = 4,
    Flowrate = 5
}
export enum Mode {
    Combination = 1,
    PH = 2,
    TSS = 3
}